import React from 'react'
import { useStyles } from './styles'

type ModelOptions = 'card' | 'table'

interface IToggleViewTableMode {
  activeMode: ModelOptions
  changeMode: (activeMode) => void
  disabled?: boolean
}

export const ToggleViewTableMode: React.FC<IToggleViewTableMode> = ({ activeMode, changeMode, disabled }) => {
  const styles = useStyles()

  return (
    <div className={styles.toggleContainer}>
      <button
        className={`${styles.toggleButton} ${activeMode === 'card' && styles.toggleActive}`}
        onClick={() => changeMode('card')} // Atualiza o estado para 'card'
        disabled={disabled}
      >
        <svg width='16' height='14' viewBox='0 0 16 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M0 12.5V1.5C0 0.671562 0.671562 0 1.5 0H14.5C15.3284 0 16 0.671562 16 1.5V12.5C16 13.3284 15.3284 14 14.5 14H1.5C0.671562 14 0 13.3284 0 12.5ZM10 13V9.66666H6V13H10ZM15 5.33334H11V8.66666H15V5.33334ZM10 5.33334H6V8.66666H10V5.33334ZM1 8.66666H5V5.33331H1V8.66666ZM5 13V9.66666H1V12.5C1 12.7762 1.22384 13 1.5 13H5ZM1 1.5V4.33334H5V1H1.5C1.22384 1 1 1.22384 1 1.5ZM6 1V4.33334H10V1H6ZM11 1V4.33334H15V1.5C15 1.22384 14.7762 1 14.5 1H11ZM15 9.66666H11V13H14.5C14.7762 13 15 12.7762 15 12.5V9.66666Z'
            fill='#784A42'
          />
        </svg>
      </button>

      <button
        className={`${styles.toggleButton} ${activeMode === 'table' && styles.toggleActive}`}
        onClick={() => changeMode('table')} // Atualiza o estado para 'table'
        disabled={disabled}
      >
        <svg width='14' height='4' viewBox='0 0 14 4' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M13.75 0H0.25C0.1125 0 0 0.1125 0 0.25V0.75C0 0.8875 0.1125 1 0.25 1H13.75C13.8875 1 14 0.8875 14 0.75V0.25C14 0.1125 13.8875 0 13.75 0ZM13.75 3H0.25C0.1125 3 0 3.1125 0 3.25V3.75C0 3.8875 0.1125 4 0.25 4H13.75C13.8875 4 14 3.8875 14 3.75V3.25C14 3.1125 13.8875 3 13.75 3Z'
            fill='#784A42'
          />
        </svg>
      </button>
    </div>
  )
}
